import { Component, HostListener } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApplicationStoreService } from '../../services/application-store.service';

@Component({
    selector: 'app-version',
    template: `
    <span
      id="version-number"
      [ngClass]="{ 'expand-version': expandVersion }"
      title="Double click to copy - {{ version }}"
      (dblclick)="copyToClipboard(version)"
      >{{ version }}</span
    >
    <div id="addin-info" [ngClass]="{ 'expand-info': expandInfo }">
      <div>Created: {{ info?.createDate }}</div>
      <div>Create Version: {{ info?.createVersion }}</div>
      <div>Current Version: {{ info?.currentVersion }}</div>
    </div>
  `,
    styleUrls: ['./build-version.scss'],
    standalone: false
})
export class VersionComponent {
  version: string = environment.version;
  expandVersion = false;
  expandInfo = false;
  info: { createDate: string; createVersion: string; currentVersion: string } | undefined;

  constructor(private applicationStoreService: ApplicationStoreService) {}

  copyToClipboard(msg: any): void {
    navigator.clipboard.writeText(msg).then(
      (_) => {},
      (err) => console.error('Failed to copy version to clipboard.', err)
    );
  }

  // Keyboard Shortcuts
  // - Use Alt + Shift + V to enlarge version number
  // - Use Alt + Shift + / to show Add In Info
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (event.altKey && event.shiftKey) {
      if (event.code === 'KeyV') {
        this.expandVersion = true;
        setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight);
        }, 200);
        setTimeout(() => {
          this.expandVersion = false;
        }, 5000);
      } else if (event.code === 'Slash') {
        this.populateInfo();
        console.log(this.info);
        this.expandInfo = true;
        setTimeout(() => {
          window.scrollTo(0, document.body.scrollHeight);
        }, 200);
        setTimeout(() => {
          this.expandInfo = false;
        }, 8000);
      }
    }
  }

  private populateInfo(): void {
    const info = this.applicationStoreService.getAddInInfo();
    const displayInfo = {
      createDate: 'unknown',
      createVersion: info.createVersion,
      currentVersion: info.currentVersion,
    };
    if (info.createDate) {
      displayInfo.createDate = new Date(info.createDate).toString().replace('British Summer Time', 'BST');
    }
    this.info = displayInfo;
  }
}
